import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { FlowStep } from '@/interfaces/requirement';
import { deofuscate } from '@/utils/obfuscation';

@Component({
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {
  CardBoxColors = BoxColors;

  id: number = 0;
  userId: number = 0;
  requirementStatus?: FlowStep[];

  constructor(
    private route: ActivatedRoute,
    private _location: Location,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.id = +params.requestId;
      this.userId = +params.userId;
    });
  }

  goBack() {
    this._location.back();
  }
}
